import apiClient from '../apiClient';

export const getAugmentationRules = (customerId, rulesetTypeId = null) => {
  const params = new URLSearchParams({ customerId });
  if (rulesetTypeId) {
    params.append('rulesetTypeId', rulesetTypeId);
  }
  return apiClient.get(`/augmentation-rules?${params}`);
};

export const getAugmentationRule = (id) => {
  return apiClient.get(`/augmentation-rules/${id}`);
};

export const createAugmentationRule = (ruleData) => {
  return apiClient.post('/augmentation-rules', ruleData);
};

export const updateAugmentationRule = (id, ruleData) => {
  return apiClient.put(`/augmentation-rules/${id}`, ruleData);
};

export const deleteAugmentationRule = (id) => {
  return apiClient.delete(`/augmentation-rules/${id}`);
};

export const activateAugmentationRule = (id) => {
  return apiClient.put(`/augmentation-rules/${id}/activate`);
};

export const deactivateAugmentationRule = (id) => {
  return apiClient.put(`/augmentation-rules/${id}/deactivate`);
};

export const cloneAugmentationRule = (id) => {
  return apiClient.post(`/augmentation-rules/${id}/clone`);
};

export const reorderAugmentationRules = (customerId, rules, extractionRulesetTypeId = null) => {
  const payload = { customerId, rules };
  if (extractionRulesetTypeId) {
    payload.extractionRulesetTypeId = parseInt(extractionRulesetTypeId, 10);
  }
  return apiClient.put('/augmentation-rules/reorder', payload);
};

export const validateAugmentationRule = (id) => {
  return apiClient.get(`/augmentation-rules/${id}/validate`);
};
